module.exports = __webpack_public_path__ + "img/Axpo_120X35.fcba8363.png";